import { memo } from "react";
import Merchants from "./Merchants";
import Onboarding from "./Onboarding";

const Home = () => (
    <>
        <Merchants />
        <Onboarding />
    </>
);

export default memo(Home);
